// define(


// 	'AGSuite.HeaderCustomization.HeaderCustomization'
// ,   [
// 		'AGSuite.HeaderCustomization.HeaderCustomization.View'
// 	,   'jQuery'
// 	]
// ,   function (
// 		HeaderCustomizationView
// 	,   jQuery
// 	)
// {
// 	'use strict';

// 	return  {
// 		mountToApp: function mountToApp (container)
// 		{
// 			var self = this;
// 			var config = {
// 				scrollThreshold: 50,        // Pixels to scroll before fixing
// 				scrollThresholdMobile: 30,  // Smaller threshold for mobile
// 				scrollThresholdTablet: 40,  // Medium threshold for tablet
// 				enableShadow: true,         // Add shadow on scroll
// 				enableBlur: false,          // Add backdrop blur effect
// 				shrinkHeader: false,        // Don't add padding to header wrapper
// 				shrinkHeaderMobile: false,  // Don't shrink on mobile
// 				throttleDelay: 10,          // Scroll event throttle delay
// 				bodyClass: 'fixed-header'   // Class name to add to body
// 			};
			
// 			jQuery(document).ready(function($) {
// 				self.addFixedHeaderStyles(config);
// 				self.initHeaderHeightDetection(config);
// 				self.initScrollDetection(config);
// 				self.handleResize(config);
// 				self.handleSidebarState(config);
// 			});

// 		},
		
// 		addFixedHeaderStyles: function(config) {
// 			var style = document.createElement('style');
// 			var shadowStyle = config.enableShadow ? 'box-shadow: 0 2px 20px rgba(0,0,0,0.15) !important;' : '';
// 			var blurStyle = config.enableBlur ? 'backdrop-filter: blur(10px) !important;' : '';
			
// 			style.textContent = `
// 				/* Base header styles for all devices - NO PADDING */
// 				.header-main-wrapper {
// 					position: fixed !important;
// 					top: 0 !important;
// 					left: 0 !important;
// 					right: 0 !important;
// 					width: 100% !important;
// 					z-index: 1000 !important;
// 					background: white !important;
// 					transition: all 0.3s ease !important;
// 				}
				
// 				/* Desktop styles when ${config.bodyClass} is added - NO PADDING */
// 				body.${config.bodyClass} .header-main-wrapper {
// 					${shadowStyle}
// 					${blurStyle}
// 					background: rgba(255,255,255,0.95) !important;
// 				}
				
// 				/* Main container padding adjustments */
// 				#main-container {
// 					transition: padding-top 0.3s ease !important;
// 				}
				
// 				/* ===== TABLET STYLES (768px - 1024px) ===== */
// 				@media (min-width: 769px) and (max-width: 1024px) {
// 					.header-main-wrapper {
// 						position: fixed !important;
// 					}
					
// 					body.${config.bodyClass} .header-main-wrapper {
// 						${shadowStyle}
// 						background: rgba(255,255,255,0.98) !important;
// 					}
					
// 					/* Adjust header content for tablet */
// 					body.${config.bodyClass} .header-logo img {
// 						max-height: 35px !important;
// 						transition: all 0.3s ease !important;
// 					}
					
// 					body.${config.bodyClass} .header-menu-nav {
// 						font-size: 14px !important;
// 					}
// 				}
				
// 				/* ===== MOBILE STYLES (up to 768px) ===== */
// 				@media (max-width: 768px) {
// 					.header-main-wrapper {
// 						position: fixed !important;
// 						background: #fff !important;
// 						border-bottom: 1px solid #eee !important;
// 					}
					
// 					/* Mobile specific styles when fixed */
// 					body.${config.bodyClass} .header-main-wrapper {
// 						box-shadow: 0 2px 15px rgba(0,0,0,0.1) !important;
// 						background: rgba(255,255,255,0.98) !important;
// 						border-bottom: none !important;
// 					}
// 					body .header-logo img{
// 						max-height: 30px !important;
// 					}
					
// 					/* Adjust logo size on mobile when fixed */
// 					body.${config.bodyClass} .header-logo img {
// 						max-height: 30px !important;
// 						transition: all 0.3s ease !important;
// 					}
					
// 					/* Hide some elements on mobile when fixed for better space usage */
// 					body.${config.bodyClass} .header-secondary-wrapper {
// 						display: none !important;
// 					}
					
// 					/* Adjust menu items for mobile */
// 					body.${config.bodyClass} .header-menu-nav {
// 						font-size: 12px !important;
// 					}
					
// 					/* Mobile menu button adjustments */
// 					body.${config.bodyClass} .header-menu-button {
// 						padding: 8px !important;
// 					}
// 				}
				
// 				/* ===== SMALL MOBILE STYLES (up to 480px) ===== */
// 				@media (max-width: 480px) {
// 					.header-main-wrapper {
// 						/* NO PADDING */
// 					}
					
// 					body .header-logo img{
// 						max-height: 60px !important;
// 					}
					
// 					body.${config.bodyClass} .header-main-wrapper {
// 						/* NO PADDING */
// 					}
					
// 					/* Even smaller logo for very small screens */
// 					body.${config.bodyClass} .header-logo img {
// 						max-height: 60px !important;
// 					}
					
// 					/* Compact menu items */
// 					body.${config.bodyClass} .header-menu-nav {
// 						font-size: 11px !important;
// 						margin: 0 5px !important;
// 					}
// 				}
				
// 				/* ===== LARGE DESKTOP STYLES (1025px and above) ===== */
// 				#main-container {
//     				transition: padding-top 0.4s ease !important;
// 				}
// 				@media (min-width: 1025px) {
// 					.header-main-wrapper {
// 						/* NO PADDING - let the original theme handle it */
// 					}
					
// 					body.${config.bodyClass} .header-main-wrapper {
// 						/* NO PADDING */
// 					}
// 				}
// 			`;
// 			document.head.appendChild(style);
// 		},
		
// 		// NEW FUNCTION: Detect and update header height dynamically
// 		initHeaderHeightDetection: function(config) {
// 			var $ = jQuery;
// 			var self = this;
			
// 			var updateMainContainerPadding = function() {
// 				var $header = $('.header-main-wrapper');
// 				var $mainContainer = $('#main-container');
				
// 				if ($header.length && $mainContainer.length) {
// 					var headerHeight = $header.outerHeight();
					
// 					// Always update padding regardless of sidebar state
// 					if (headerHeight > 0) {
// 						$mainContainer.css('padding-top', headerHeight + 'px');
// 						console.log('Updated #main-container padding-top to: ' + headerHeight + 'px');
// 					}
// 				}
// 			};
			
// 			// Initial update
// 			$(window).on('load', function() {
// 				setTimeout(updateMainContainerPadding, 100);
// 			});
			
// 			// Update on resize
// 			var resizeTimer;
// 			$(window).on('resize', function() {
// 				clearTimeout(resizeTimer);
// 				resizeTimer = setTimeout(function() {
// 					updateMainContainerPadding();
// 				}, 250);
// 			});
			
// 			// Update when fixed header class is toggled (header might shrink/expand)
// 			var $body = $('body');
// 			var observer = new MutationObserver(function(mutations) {
// 				mutations.forEach(function(mutation) {
// 					if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
// 						setTimeout(updateMainContainerPadding, 50);
// 					}
// 				});
// 			});
			
// 			if ($body.length) {
// 				observer.observe($body[0], {
// 					attributes: true,
// 					attributeFilter: ['class']
// 				});
// 			}
			
// 			// Also update after any potential DOM changes that might affect header height
// 			var domObserver = new MutationObserver(function(mutations) {
// 				var shouldUpdate = false;
// 				mutations.forEach(function(mutation) {
// 					if (mutation.type === 'childList') {
// 						// Check if header or its children were modified
// 						var $target = $(mutation.target);
// 						if ($target.closest('.header-main-wrapper').length || 
// 							$target.closest('#main-container').length) {
// 							shouldUpdate = true;
// 						}
// 					}
// 				});
// 				if (shouldUpdate) {
// 					setTimeout(updateMainContainerPadding, 100);
// 				}
// 			});
			
// 			// Observe the entire document for changes that might affect header height
// 			domObserver.observe(document.body, {
// 				childList: true,
// 				subtree: true
// 			});
// 		},
		
// 		initScrollDetection: function(config) {
// 			var $ = jQuery;
// 			var $body = $('body');
// 			var currentThreshold = config.scrollThreshold;
// 			var self = this;
			
// 			// Define functions first so they're accessible everywhere
// 			var updateScrollThreshold = function() {
// 				var windowWidth = $(window).width();
				
// 				if (windowWidth <= 480) {
// 					// Small mobile
// 					currentThreshold = config.scrollThresholdMobile || 20;
// 				} else if (windowWidth <= 768) {
// 					// Mobile
// 					currentThreshold = config.scrollThresholdMobile || 30;
// 				} else if (windowWidth <= 1024) {
// 					// Tablet
// 					currentThreshold = config.scrollThresholdTablet || 40;
// 				} else {
// 					// Desktop
// 					currentThreshold = config.scrollThreshold;
// 				}
				
// 				console.log('Scroll threshold updated to: ' + currentThreshold + 'px for ' + getDeviceType());
// 			};
			
// 			// Helper function to check if we should skip fixed header
// 			var shouldSkipFixedHeader = function() {
// 				var $body = $('body');
// 				var windowWidth = $(window).width();
// 				var isMobileOrTablet = windowWidth <= 1024;
// 				var isSidebarOpened = $body.hasClass('header-sidebar-opened');
				
// 				return isMobileOrTablet && isSidebarOpened;
// 			};
			
// 			var handleScroll = function() {
// 				// Don't apply fixed header when sidebar is opened on mobile/tablet
// 				if (shouldSkipFixedHeader()) {
// 					if ($body.hasClass(config.bodyClass)) {
// 						$body.removeClass(config.bodyClass);
// 					}
// 					return;
// 				}
				
// 				var scrollTop = $(window).scrollTop();
// 				var hasClass = $body.hasClass(config.bodyClass);
				
// 				if (scrollTop > currentThreshold) {
// 					if (!hasClass) {
// 						$body.addClass(config.bodyClass);
// 						console.log('Fixed header activated - Device: ' + getDeviceType());
// 						// Update padding after fixed header class is applied
// 						setTimeout(self.initHeaderHeightDetection.bind(self, config), 50);
// 					}
// 				} else {
// 					if (hasClass) {
// 						$body.removeClass(config.bodyClass);
// 						console.log('Fixed header deactivated - Device: ' + getDeviceType());
// 						// Update padding after fixed header class is removed
// 						setTimeout(self.initHeaderHeightDetection.bind(self, config), 50);
// 					}
// 				}
// 			};
			
// 			// Helper function to detect device type
// 			var getDeviceType = function() {
// 				var width = $(window).width();
// 				if (width <= 480) return 'small-mobile';
// 				if (width <= 768) return 'mobile';
// 				if (width <= 1024) return 'tablet';
// 				return 'desktop';
// 			};
			
// 			// Throttled scroll event
// 			var scrollTimer;
// 			$(window).on('scroll', function() {
// 				clearTimeout(scrollTimer);
// 				scrollTimer = setTimeout(handleScroll, config.throttleDelay);
// 			});
			
// 			// Handle resize to update thresholds
// 			var resizeTimer;
// 			$(window).on('resize', function() {
// 				clearTimeout(resizeTimer);
// 				resizeTimer = setTimeout(function() {
// 					updateScrollThreshold();
// 					handleScroll(); // Re-check scroll position after resize
// 					// Also update header height detection
// 					self.initHeaderHeightDetection(config);
// 				}, 250);
// 			});
			
// 			// Handle page load with hash in URL
// 			$(window).on('load', function() {
// 				updateScrollThreshold();
// 				handleScroll();
// 			});
			
// 			// Initial setup
// 			updateScrollThreshold();
// 			handleScroll();
// 		},
		
// 		handleResize: function(config) {
// 			var $ = jQuery;
			
// 			// Add device class to body for more specific targeting
// 			function updateBodyDeviceClass() {
// 				var width = $(window).width();
// 				var deviceClass = '';
				
// 				if (width <= 480) {
// 					deviceClass = 'device-mobile-small';
// 				} else if (width <= 768) {
// 					deviceClass = 'device-mobile';
// 				} else if (width <= 1024) {
// 					deviceClass = 'device-tablet';
// 				} else {
// 					deviceClass = 'device-desktop';
// 				}
				
// 				$('body')
// 					.removeClass('device-mobile-small device-mobile device-tablet device-desktop')
// 					.addClass(deviceClass);
// 			}
			
// 			// Initial call
// 			updateBodyDeviceClass();
			
// 			// Update on resize
// 			var resizeTimer;
// 			$(window).on('resize', function() {
// 				clearTimeout(resizeTimer);
// 				resizeTimer = setTimeout(updateBodyDeviceClass, 100);
// 			});
// 		},
		
// 		// Updated function to handle sidebar state changes - SIMPLIFIED
// 		handleSidebarState: function(config) {
// 			var $ = jQuery;
// 			var $body = $('body');
// 			var $main = $('#main');
			
// 			// Create a MutationObserver to watch for class changes on #main
// 			var observer = new MutationObserver(function(mutations) {
// 				mutations.forEach(function(mutation) {
// 					if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
// 						var isSidebarOpened = $main.hasClass('header-sidebar-opened');
// 						var windowWidth = $(window).width();
// 						var isMobileOrTablet = windowWidth <= 1024;
						
// 						if (isMobileOrTablet && isSidebarOpened) {
// 							// Sidebar opened on mobile/tablet - remove fixed header but KEEP padding
// 							$body.removeClass(config.bodyClass);
// 							console.log('Sidebar opened - removed fixed header but kept padding');
// 						} else {
// 							// Sidebar closed or desktop - re-apply scroll detection
// 							setTimeout(function() {
// 								$(window).trigger('scroll');
// 							}, 100);
// 							console.log('Sidebar closed - re-applied scroll detection');
// 						}
// 					}
// 				});
// 			});
			
// 			// Start observing the #main element for class changes
// 			if ($main.length) {
// 				observer.observe($main[0], {
// 					attributes: true,
// 					attributeFilter: ['class']
// 				});
// 				console.log('Started observing sidebar state changes');
// 			}
			
// 			// Also listen for click events on menu buttons as a fallback
// 			$(document).on('click', '.header-menu-button, .header-sidebar-close', function() {
// 				setTimeout(function() {
// 					var isSidebarOpened = $main.hasClass('header-sidebar-opened');
// 					var windowWidth = $(window).width();
// 					var isMobileOrTablet = windowWidth <= 1024;
					
// 					if (isMobileOrTablet && isSidebarOpened) {
// 						$body.removeClass(config.bodyClass);
// 					} else {
// 						$(window).trigger('scroll');
// 					}
// 				}, 300);
// 			});
// 		}
// 	};
// });



define(
	'AGSuite.HeaderCustomization.HeaderCustomization'
,   [
		'AGSuite.HeaderCustomization.HeaderCustomization.View'
	,   'jQuery'
	]
,   function (
		HeaderCustomizationView
	,   jQuery
	)
{
	'use strict';

	return  {
		mountToApp: function mountToApp (container)
		{
			var self = this;
			var config = {
				scrollThreshold: 50,        // Pixels to scroll before fixing
				scrollThresholdMobile: 30,  // Smaller threshold for mobile
				scrollThresholdTablet: 40,  // Medium threshold for tablet
				enableShadow: true,         // Add shadow on scroll
				enableBlur: false,          // Add backdrop blur effect
				shrinkHeader: false,        // Don't add padding to header wrapper
				shrinkHeaderMobile: false,  // Don't shrink on mobile
				throttleDelay: 10,          // Scroll event throttle delay
				bodyClass: 'fixed-header'   // Class name to add to body
			};
			
			jQuery(document).ready(function($) {
				self.addFixedHeaderStyles(config);
				self.initHeaderHeightDetection(config);
				self.initScrollDetection(config);
				self.handleResize(config);
				self.handleSidebarState(config);
			});

		},
		
		addFixedHeaderStyles: function(config) {
			var style = document.createElement('style');
			var shadowStyle = config.enableShadow ? 'box-shadow: 0 2px 20px rgba(0,0,0,0.15) !important;' : '';
			var blurStyle = config.enableBlur ? 'backdrop-filter: blur(10px) !important;' : '';
			
			style.textContent = `
				/* Base header styles for all devices - NO PADDING */
				.header-main-wrapper {
					position: fixed !important;
					top: 0 !important;
					left: 0 !important;
					right: 0 !important;
					width: 100% !important;
					z-index: 1000 !important;
					background: white !important;
					transition: all 0.3s ease !important;
				}
				
				/* Desktop styles when ${config.bodyClass} is added - NO PADDING */
				body.${config.bodyClass} .header-main-wrapper {
					${shadowStyle}
					${blurStyle}
					background: rgba(255,255,255,0.95) !important;
				}
				
				/* Main container padding adjustments */
				#main-container {
					transition: padding-top 0.3s ease !important;
				}
				
				/* ===== TABLET STYLES (768px - 1024px) ===== */
				@media (min-width: 769px) and (max-width: 1024px) {
					.header-main-wrapper {
						position: fixed !important;
					}
					
					body.${config.bodyClass} .header-main-wrapper {
						${shadowStyle}
						background: rgba(255,255,255,0.98) !important;
					}
					
					/* Adjust header content for tablet */
					body.${config.bodyClass} .header-logo img {
						max-height: 35px !important;
						transition: all 0.3s ease !important;
					}
					
					body.${config.bodyClass} .header-menu-nav {
						font-size: 14px !important;
					}
				}
				
				/* ===== MOBILE STYLES (up to 768px) ===== */
				@media (max-width: 768px) {
					.header-main-wrapper {
						position: fixed !important;
						background: #fff !important;
						border-bottom: 1px solid #eee !important;
					}
					
					/* Mobile specific styles when fixed */
					body.${config.bodyClass} .header-main-wrapper {
						box-shadow: 0 2px 15px rgba(0,0,0,0.1) !important;
						background: rgba(255,255,255,0.98) !important;
						border-bottom: none !important;
					}
					body .header-logo img{
						max-height: 30px !important;
					}
					
					/* Adjust logo size on mobile when fixed */
					body.${config.bodyClass} .header-logo img {
						max-height: 30px !important;
						transition: all 0.3s ease !important;
					}
					
					/* Hide some elements on mobile when fixed for better space usage */
					body.${config.bodyClass} .header-secondary-wrapper {
						display: none !important;
					}
					
					/* Adjust menu items for mobile */
					body.${config.bodyClass} .header-menu-nav {
						font-size: 12px !important;
					}
					
					/* Mobile menu button adjustments */
					body.${config.bodyClass} .header-menu-button {
						padding: 8px !important;
					}
				}
				
				/* ===== SMALL MOBILE STYLES (up to 480px) ===== */
				@media (max-width: 480px) {
					.header-main-wrapper {
						/* NO PADDING */
					}
					
					body .header-logo img{
						max-height: 60px !important;
					}
					
					body.${config.bodyClass} .header-main-wrapper {
						/* NO PADDING */
					}
					
					/* Even smaller logo for very small screens */
					body.${config.bodyClass} .header-logo img {
						max-height: 60px !important;
					}
					
					/* Compact menu items */
					body.${config.bodyClass} .header-menu-nav {
						font-size: 11px !important;
						margin: 0 5px !important;
					}
				}
				
				/* ===== LARGE DESKTOP STYLES (1025px and above) ===== */
				#main-container {
    				transition: padding-top 0.4s ease !important;
				}
				@media (min-width: 1025px) {
					.header-main-wrapper {
						/* NO PADDING - let the original theme handle it */
					}
					
					body.${config.bodyClass} .header-main-wrapper {
						/* NO PADDING */
					}
				}
			`;
			document.head.appendChild(style);
		},
		
		// NEW FUNCTION: Detect and update header height dynamically
		initHeaderHeightDetection: function(config) {
			var $ = jQuery;
			var self = this;
			
			var updateMainContainerPadding = function() {
				var $header = $('.header-main-wrapper');
				var $mainContainer = $('#main-container');
				
				if ($header.length && $mainContainer.length) {
					var headerHeight = $header.outerHeight();
					
					// Always update padding regardless of sidebar state
					if (headerHeight > 0) {
						$mainContainer.css('padding-top', headerHeight + 'px');
						console.log('Updated #main-container padding-top to: ' + headerHeight + 'px');
					}
				}
			};
			
			// Make this function globally accessible
			self.updateMainContainerPadding = updateMainContainerPadding;
			
			// Initial update
			$(window).on('load', function() {
				setTimeout(updateMainContainerPadding, 100);
			});
			
			// Update on resize
			var resizeTimer;
			$(window).on('resize', function() {
				clearTimeout(resizeTimer);
				resizeTimer = setTimeout(function() {
					updateMainContainerPadding();
				}, 250);
			});
			
			// Update when fixed header class is toggled (header might shrink/expand)
			var $body = $('body');
			var observer = new MutationObserver(function(mutations) {
				mutations.forEach(function(mutation) {
					if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
						setTimeout(updateMainContainerPadding, 50);
					}
				});
			});
			
			if ($body.length) {
				observer.observe($body[0], {
					attributes: true,
					attributeFilter: ['class']
				});
			}
			
			// Also update after any potential DOM changes that might affect header height
			var domObserver = new MutationObserver(function(mutations) {
				var shouldUpdate = false;
				mutations.forEach(function(mutation) {
					if (mutation.type === 'childList') {
						// Check if header or its children were modified
						var $target = $(mutation.target);
						if ($target.closest('.header-main-wrapper').length || 
							$target.closest('#main-container').length) {
							shouldUpdate = true;
						}
					}
				});
				if (shouldUpdate) {
					setTimeout(updateMainContainerPadding, 100);
				}
			});
			
			// Observe the entire document for changes that might affect header height
			domObserver.observe(document.body, {
				childList: true,
				subtree: true
			});
		},
		
		initScrollDetection: function(config) {
			var $ = jQuery;
			var $body = $('body');
			var currentThreshold = config.scrollThreshold;
			var self = this;
			
			// Define functions first so they're accessible everywhere
			var updateScrollThreshold = function() {
				var windowWidth = $(window).width();
				
				if (windowWidth <= 480) {
					// Small mobile
					currentThreshold = config.scrollThresholdMobile || 20;
				} else if (windowWidth <= 768) {
					// Mobile
					currentThreshold = config.scrollThresholdMobile || 30;
				} else if (windowWidth <= 1024) {
					// Tablet
					currentThreshold = config.scrollThresholdTablet || 40;
				} else {
					// Desktop
					currentThreshold = config.scrollThreshold;
				}
				
				console.log('Scroll threshold updated to: ' + currentThreshold + 'px for ' + getDeviceType());
			};
			
			// Helper function to check if we should skip fixed header
			var shouldSkipFixedHeader = function() {
				var $body = $('body');
				var windowWidth = $(window).width();
				var isMobileOrTablet = windowWidth <= 1024;
				var isSidebarOpened = $body.hasClass('header-sidebar-opened');
				
				return isMobileOrTablet && isSidebarOpened;
			};
			
			var handleScroll = function() {
				// Don't apply fixed header when sidebar is opened on mobile/tablet
				if (shouldSkipFixedHeader()) {
					if ($body.hasClass(config.bodyClass)) {
						$body.removeClass(config.bodyClass);
					}
					return;
				}
				
				var scrollTop = $(window).scrollTop();
				var hasClass = $body.hasClass(config.bodyClass);
				
				if (scrollTop > currentThreshold) {
					if (!hasClass) {
						$body.addClass(config.bodyClass);
						console.log('Fixed header activated - Device: ' + getDeviceType());
						// Update padding after fixed header class is applied
						setTimeout(self.updateMainContainerPadding, 50);
					}
				} else {
					if (hasClass) {
						$body.removeClass(config.bodyClass);
						console.log('Fixed header deactivated - Device: ' + getDeviceType());
						// Update padding after fixed header class is removed
						setTimeout(self.updateMainContainerPadding, 50);
					}
				}
			};
			
			// Helper function to detect device type
			var getDeviceType = function() {
				var width = $(window).width();
				if (width <= 480) return 'small-mobile';
				if (width <= 768) return 'mobile';
				if (width <= 1024) return 'tablet';
				return 'desktop';
			};
			
			// Throttled scroll event
			var scrollTimer;
			$(window).on('scroll', function() {
				clearTimeout(scrollTimer);
				scrollTimer = setTimeout(handleScroll, config.throttleDelay);
			});
			
			// Handle resize to update thresholds
			var resizeTimer;
			$(window).on('resize', function() {
				clearTimeout(resizeTimer);
				resizeTimer = setTimeout(function() {
					updateScrollThreshold();
					handleScroll(); // Re-check scroll position after resize
					// Also update header height detection
					self.updateMainContainerPadding();
				}, 250);
			});
			
			// Handle page load with hash in URL
			$(window).on('load', function() {
				updateScrollThreshold();
				handleScroll();
			});
			
			// Initial setup
			updateScrollThreshold();
			handleScroll();
		},
		
		handleResize: function(config) {
			var $ = jQuery;
			
			// Add device class to body for more specific targeting
			function updateBodyDeviceClass() {
				var width = $(window).width();
				var deviceClass = '';
				
				if (width <= 480) {
					deviceClass = 'device-mobile-small';
				} else if (width <= 768) {
					deviceClass = 'device-mobile';
				} else if (width <= 1024) {
					deviceClass = 'device-tablet';
				} else {
					deviceClass = 'device-desktop';
				}
				
				$('body')
					.removeClass('device-mobile-small device-mobile device-tablet device-desktop')
					.addClass(deviceClass);
			}
			
			// Initial call
			updateBodyDeviceClass();
			
			// Update on resize
			var resizeTimer;
			$(window).on('resize', function() {
				clearTimeout(resizeTimer);
				resizeTimer = setTimeout(updateBodyDeviceClass, 100);
			});
		},
		
		// Updated function to handle sidebar state changes - FIXED
		handleSidebarState: function(config) {
			var $ = jQuery;
			var $body = $('body');
			var $main = $('#main');
			var self = this;
			
			// Create a MutationObserver to watch for class changes on #main
			var observer = new MutationObserver(function(mutations) {
				mutations.forEach(function(mutation) {
					if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
						var isSidebarOpened = $main.hasClass('header-sidebar-opened');
						var windowWidth = $(window).width();
						var isMobileOrTablet = windowWidth <= 1024;
						
						if (isMobileOrTablet && isSidebarOpened) {
							// Sidebar opened on mobile/tablet - remove fixed header but KEEP padding
							$body.removeClass(config.bodyClass);
							console.log('Sidebar opened - removed fixed header but kept padding');
						} else {
							// Sidebar closed - re-apply padding and scroll detection
							setTimeout(function() {
								// Force update of padding
								self.updateMainContainerPadding();
								// Re-trigger scroll detection
								$(window).trigger('scroll');
								console.log('Sidebar closed - re-applied padding and scroll detection');
							}, 300); // Increased timeout to ensure sidebar animation is complete
						}
					}
				});
			});
			
			// Start observing the #main element for class changes
			if ($main.length) {
				observer.observe($main[0], {
					attributes: true,
					attributeFilter: ['class']
				});
				console.log('Started observing sidebar state changes');
			}
			
			// Also listen for click events on menu buttons as a fallback
			$(document).on('click', '.header-menu-button, .header-sidebar-close', function() {
				setTimeout(function() {
					var isSidebarOpened = $main.hasClass('header-sidebar-opened');
					var windowWidth = $(window).width();
					var isMobileOrTablet = windowWidth <= 1024;
					
					if (isMobileOrTablet && isSidebarOpened) {
						$body.removeClass(config.bodyClass);
					} else {
						// Sidebar closing - update padding and trigger scroll
						self.updateMainContainerPadding();
						setTimeout(function() {
							$(window).trigger('scroll');
						}, 100);
					}
				}, 400); // Wait for sidebar animation to complete
			});
		}
	};
});
